import { PhosphorFloppyButton } from "components/Atoms/PhosphorIconButton";
import React from "react";
import { Input } from "semantic-ui-react";

interface Props {
  initialSubject: server.dto.FavoriteSubject
  onCreate?: (subject: server.dto.FavoriteSubject) => void
  onEdit?: (subject: server.dto.FavoriteSubject) => void
}

const EditedSubjectRowCard = (props: Props) => {
  const [subject, setSubject] = React.useState<server.dto.FavoriteSubject>(props.initialSubject);
  const [hasError, setHasError] = React.useState<boolean>(false);
  const [isSaving, setIsSaving] = React.useState<boolean>(false);

  const update = (_, { value }) => {
    setSubject({ ...subject, subjectValue: value });
    setHasError(false);
  };

  const onSaveClick = () => {
    if (isSaving) {
      return;
    }

    if (subject.subjectValue.trim() === "") {
      setHasError(true);
      return;
    }

    setIsSaving(true);
    props.onCreate ? props.onCreate(subject) : props.onEdit(subject);
  };

  const onKeyPress = (event: KeyboardEvent) => {
    if (event.key === "Enter") {
      event.preventDefault();
      onSaveClick();
    }
  };

  return <div>
    <div className="grow1">
      <Input onKeyPress={onKeyPress} fluid disabled={isSaving} error={hasError} value={subject.subjectValue} onChange={update} maxLength={25} />
    </div>
    <PhosphorFloppyButton
      layout="in-square"
      onClick={onSaveClick}
    />
  </div>;
};

export default EditedSubjectRowCard;